import{ useContext, useEffect, useState } from "react";
import { OperationContext } from "../CreateOperation";
import { TitleBadge } from "../components/TitleBadge";
import { CollapseProps, Empty } from "antd";
import { FormatDate } from "../../../../../utilities/formatDate";
import dayjs from "dayjs";
import { TimesheetTable } from "./tableContent/TimesheetTable";
import { CustomCollapse } from "../../../../../common/components/Collapse/Collapse";
import { ExportPdf } from "../../../../../common/components/Export/ExportPdf";
import { TimesheetDateNavigation } from "../components/DateNavigation";

export const TimesheetOperations = () => {
  const { initialValue, filter, setFilter } = useContext(OperationContext);
  // const [hasTimesheetData, setHasTimesheetData] = useState<boolean | null>(null);

  const hasManifesto = !!initialValue?.loadsTxt;

  const teams: CollapseProps["items"] =
    initialValue?.teamsArray?.map((team: any) => ({
      key: team.id,
      label: team.name,
      children: <TimesheetTable team={team} /* onDateAvailabilityChange={setHasTimesheetData} *//>,
    })) ?? [];

    useEffect(() => {
      if (!initialValue?.startAt) return;
    
      const firstDate = dayjs(initialValue.startAt).format("YYYY-MM-DD");
    
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: firstDate,
      }));
    }, [initialValue?.startAt]);

    const handleDateFilter = (value: string) => {
      // setHasTimesheetData(null);

      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: value,
      }));
    };

  return (
    <div className="">
    {hasManifesto ? (
      <>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-wrap gap-2 mb-4">
            <TitleBadge
              label="Référence du voyage"
              value={initialValue?.travelReference}
            />
            <TitleBadge
              label="Opération"
              value={initialValue?.operationType?.label}
            />
            {/* <TitleBadge label="Equipe Cabotage" value={initialValue?.customer?.label} /> */}
            <TitleBadge label="Client" value={initialValue?.customer?.label} />
            {/* <TitleBadge
            label="TDM"
            value={initialValue?.myTeamHandlingTechnicians}
          /> */}
            <TitleBadge label="Navire" value={initialValue?.ship} />
            {initialValue?.estimatedArrivalAt && (
              <TitleBadge
                label="Date d'arrivée prévue"
                value={FormatDate.formatDateToDisplay(
                  initialValue?.estimatedArrivalAt
                )}
              />
            )}
            {/* <TitleBadge
            label=""
            value={initialValue?.myTeamHandlingTechnicians}
          /> */}
          </div>
          {initialValue?.startAt && filter?.teamsCreatedAt && (
          <div>
            <ExportPdf
              uri={`/api/time-sheet/${initialValue.id}/pdf`}
              params={{
                dates: [filter.teamsCreatedAt],
              }}
            />
          </div>
          )}
        </div>
        <div>
          {initialValue?.startAt && filter?.teamsCreatedAt ? (
            <>
              <TimesheetDateNavigation
                startDate={initialValue.startAt}
                selectedDate={filter.teamsCreatedAt}
                onChange={handleDateFilter}
              />

              <CustomCollapse items={teams} />
            </>
          ) : (
            <Empty description="Le timesheet sera disponible au démarrage de l’opération." />
          )}
        </div>
      </>
    ) : (
      <Empty description="En attente de manifeste" />
    )}
  </div>
  
  );
};
